import { useRef } from "react";

/** Wrap a value in a ref so we can reference it later without having to re-render things. The linter will complain unless you put the ref itself in the dependency lists for hooks but it's fine to do so as the ref itself will not change. */
export default function useRefOf<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
